import {Directive} from '@angular/core';

@Directive({
    selector: '[cbTableRow]',
    standalone: false
})
export class CbTableRowDirective {
}
